import { AssetSearchResult } from "../api/asset/search/assetSearchResult";
import { truncateString } from "./text-utils";

export function getAssetDisplayName(asset: AssetSearchResult): string {
    if (!asset.typeCode && !asset.serialNumber) {
        return "Type code and serial number are not available";
    }

    if (!asset.typeCode || asset.typeCode.trim() == "") {
        return asset.serialNumber!;
    }
    else {
        const typeCode = truncateString(asset.typeCode.trim(), 20);
        return asset.serialNumber + " (" + typeCode + ")";
    }
}